export const REG_PATHS = ["registration", "registrationofPartition", "newUserPassword", "credential", "newpassword"]

export const PUBLIC_PATHS = ["forgot-password", "recoveryPassword", "page-login", "register-cardholder", "register", "Register", "Register-company",
  "credential", "guest-credential", "New-User-Password", "New-Partition-Password"
]